import { type Meta } from '../types/docs';
import { ONBOARDING_ANALYTICS_CATEGORY_META_PARAM } from './onboardingAnalytics';

const META: Meta = {
  description: 'Event sent when a user views the onboarding company size step',
  name: 'Viewed onboarding company size',
  params: [ONBOARDING_ANALYTICS_CATEGORY_META_PARAM],
};

export default META;
